import { storage } from 'packages/kakapo-ui-services/factories/PersistentStorageFactory';
import { IKeyValueStorage } from 'packages/kakapo-ui-services/factories/SessionStorageFactory';

class LanguageService {
	defaultLanguage: string = 'en';

	storage: IKeyValueStorage = storage;

	get currentLanguage(): string {
		return this.storage.getItem('language') || this.defaultLanguage;
	}

	set currentLanguage(currentLanguage: string) {
		this.storage.setItem('language', currentLanguage);
	}

	languageNames = (): Record<string, string> => {
		return {
			nl: 'Dutch (Nederlands)',
			en: 'English (UK)',
			de: 'German',
			fr: 'French',
		};
	};
}

export default LanguageService;
